import { useIntl } from 'react-intl'

import { type FallbackRender } from '@sentry/react'

import { ErrorTemplate } from '@/components/templates/Error/ErrorTemplate'

// eslint-disable-next-line @typescript-eslint/unbound-method
export const SentryErrorPage: FallbackRender = ({ resetError }) => {
  const intl = useIntl()

  return <ErrorTemplate title={intl.formatMessage({ id: 'errors.generic.title' })} onClick={resetError} />
}
